import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './Header.css';

export default function Header() {
  const { user, logout } = useAuth();
  // Only render the header when there's a logged-in user; login/signup pages don't need it.
  if (!user) return null;
  return (
    <header className="tb-header">
      <div className="tb-header-inner">
        <div className="tb-brand">Tapebrief</div>
        <nav className="tb-nav">
          <NavLink to="/market-news" className={({ isActive }) => 'tb-nav-link' + (isActive ? ' active' : '')}>
            Market News
          </NavLink>
          <NavLink to="/watchlist-brief" className={({ isActive }) => 'tb-nav-link' + (isActive ? ' active' : '')}>
            Watchlist Brief
          </NavLink>
        </nav>
        <div className="tb-user">
          <span className="tb-username">{user.username}</span>
          <button className="tb-logout" onClick={logout}>Sign out</button>
        </div>
      </div>
    </header>
  );
}
